// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3yi8K","col":"styles_col__MfaA3"};